var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowImportContactsOutlookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.302,
    height: 54.516,
    viewBox: "0 0 55.302 54.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M35.542,69.984a1.272,1.272,0,0,0-1.984-.039C27.452,77.277,20.76,83.223,11.85,81.7a1.275,1.275,0,0,0-1.46.955l-.007.027A1.276,1.276,0,0,0,11.4,84.235a19.1,19.1,0,0,0,3.256.284c8.546,0,15.126-6.03,20.877-12.918a1.275,1.275,0,0,0,.026-1.595Z",
    transform: "translate(-10.348 -39.403)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M67.813,34.979a1.272,1.272,0,0,0,2,0c5.936-7.589,11.751-14.156,19.041-13.263L83.275,27.29a1.34,1.34,0,0,0-.125,1.794,1.293,1.293,0,0,0,.987.464,1.268,1.268,0,0,0,.907-.381l7.932-7.932a1.288,1.288,0,0,0,0-1.824L85.1,11.528a1.34,1.34,0,0,0-1.809-.118,1.294,1.294,0,0,0-.066,1.886l5.834,5.839C80.5,18.118,73.974,25.474,67.788,33.378a1.277,1.277,0,0,0,.007,1.578Z",
    transform: "translate(-38.053 -11.113)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M65.276,64.313,57.344,56.38A1.288,1.288,0,1,0,55.522,58.2l5.63,5.631c-8.019.984-14.257-7.069-20.83-15.566C32.741,38.461,24.181,27.391,11.409,29.6a1.278,1.278,0,0,0-1.019,1.556l.007.028a1.275,1.275,0,0,0,1.461.953C23.1,30.209,30.82,40.186,38.288,49.843c6.352,8.214,12.89,16.67,21.489,16.67a13.435,13.435,0,0,0,1.585-.1L55.521,72.25a1.288,1.288,0,0,0,1.822,1.822l7.933-7.937a1.288,1.288,0,0,0,0-1.822Z",
    transform: "translate(-10.351 -19.934)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImportContactsOutlookIcon);
export default __webpack_public_path__ + "static/media/arrow-import-contacts-outlook-icon.ddd6753fd05496af90be36b6ee144e43.svg";
export { ForwardRef as ReactComponent };